__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "components";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.34.0", function() { return __webpack_require__.e(918).then(function() { return function() { return __webpack_require__(4918); }; }); });
			register("@azure/msal-react", "1.5.4", function() { return Promise.all([__webpack_require__.e(302), __webpack_require__.e(896)]).then(function() { return function() { return __webpack_require__(8302); }; }); });
			register("@emotion/react", "11.10.6", function() { return Promise.all([__webpack_require__.e(361), __webpack_require__.e(307)]).then(function() { return function() { return __webpack_require__(8307); }; }); });
			register("@emotion/styled", "11.10.6", function() { return Promise.all([__webpack_require__.e(82), __webpack_require__.e(225)]).then(function() { return function() { return __webpack_require__(225); }; }); });
			register("@mui/material", "5.11.15", function() { return Promise.all([__webpack_require__.e(391), __webpack_require__.e(791), __webpack_require__.e(82), __webpack_require__.e(773), __webpack_require__.e(945), __webpack_require__.e(300), __webpack_require__.e(664)]).then(function() { return function() { return __webpack_require__(1791); }; }); });
			register("@mui/system", "5.11.15", function() { return Promise.all([__webpack_require__.e(361), __webpack_require__.e(391), __webpack_require__.e(28), __webpack_require__.e(82), __webpack_require__.e(945), __webpack_require__.e(448)]).then(function() { return function() { return __webpack_require__(8470); }; }); });
			register("react-dom", "18.2.0", function() { return function() { return __webpack_require__(4164); }; }, 1);
			register("react-i18next", "12.2.0", function() { return __webpack_require__.e(112).then(function() { return function() { return __webpack_require__(781); }; }); });
			register("react-idle-timer", "5.6.2", function() { return Promise.all([__webpack_require__.e(403), __webpack_require__.e(760)]).then(function() { return function() { return __webpack_require__(3239); }; }); });
			register("react-router-dom", "6.9.0", function() { return Promise.all([__webpack_require__.e(403), __webpack_require__.e(565), __webpack_require__.e(942)]).then(function() { return function() { return __webpack_require__(9565); }; }); });
			register("react", "18.2.0", function() { return function() { return __webpack_require__(2791); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};